import { ssrBackedReactContextFeaturesStoreFactory as featuresStoreFactory } from "@asosteam/asos-web-toggle-point-features";
import { logWarning } from "../client/monitoring";
import { APP_SHORT_NAME as namespace } from "./constants";

const { getFeatures, providerFactory } = featuresStoreFactory({
  namespace,
  name: "experiments",
  logWarning
});

export { getFeatures, providerFactory };
